// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"4a83cd7c","625":"e7d27a7d","976":"4eb21063"}[chunkId] + ".chunk.js";
};